import {
    GET_PRICEOM_CONFIG_REQUEST,
    GET_PRICEOM_CONFIG_REQUEST_SUCCESS,
    GET_PRICEOM_CONFIG_REQUEST_FAILURE,
    CHANGE_PRICEOM_CONFIG_REQUEST,
    CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS,
    CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE,
} from '../constants/priceom_config.constants';

const initialState = {
    loading: false,
    config: null,
    config_id: null,
    error: null,
};

export const Price_o_matic_update = (state = initialState, action) => {
    switch (action.type) {
    case GET_PRICEOM_CONFIG_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CHANGE_PRICEOM_CONFIG_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_PRICEOM_CONFIG_REQUEST_SUCCESS:
        return {
            ...state,
            loading: true,
            config: action.payload,
            config_id: action.payload._id,
        };
    case CHANGE_PRICEOM_CONFIG_REQUEST_SUCCESS:
        return {
            ...state,
            loading: true,
            config: action.payload,
        };
    case GET_PRICEOM_CONFIG_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    case CHANGE_PRICEOM_CONFIG_REQUEST_FAILURE:
        return {
            ...state,
            error: action.error,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/reducers/priceomatic_config.reducers.js